import { xhr } from '@/api/config/Repository'
import OrderManagementFileUploadRepository from '../OrderManagementFileUploadRepository'
import UploadOrderFileRequestDTO from '../dto/uploadOrderFileRequestDTO'
import OrderFilesDetailsRequest from '@/services/orderManagementFileUpload/models/OrderFilesDetailsRequest'
import OrderFilesDetailsResponseDTO from '../dto/OrderFilesDetailsResponseDTO'
import ViewOrderFilesDetailsRequest from '@/services/orderManagementFileUpload/models/ViewOrderFilesDetailsRequest'
import ViewOrderFilesDetailsResponseDTO from '../dto/ViewOrderFilesDetailsResponseDTO'
import DeleteOrderFileRequest from '@/services/orderManagementFileUpload/models/DeleteOrderFileRequest'
import DeleteOrderFileResponse from '@/services/orderManagementFileUpload/models/DeleteOrderFileResponse'
import UpdateOrderDetailsRequest from '@/services/orderManagementFileUpload/models/UpdateOrderDetailsRequest'
import ViewOrderProcessLogsResponseDTO from '../dto/ViewOrderProcessLogsResponseDTO'

export default class OrderManagementFileUploadRepositoryImpl implements OrderManagementFileUploadRepository {
  async uploadOrderFileData (request: UploadOrderFileRequestDTO): Promise<any> {
    const formData = request.data
    const endpoint = 'order/createOrderFile'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }

    const response = await xhr.post<any, any>(endpoint, formData, { headers })
    console.log('LOG~ ~ file: OrderManagementFileUploadRepositoryImpl.ts:22 ~ uploadOrderFileData ~ response:', response)
    return {
      content: response.data,
      status: response.status
    }
  }

  async getOrderFilesDetailData (paramData: OrderFilesDetailsRequest): Promise<any> {
    const reqBody: OrderFilesDetailsRequest = {
      pageNumber: paramData.pageNumber,
      pageSize: paramData.pageSize,
      sortBy: paramData.sortBy,
      countryId: paramData.countryId,
      supplierId: paramData.supplierId,
      warehouseId: paramData.warehouseId,
      monthConcerned: paramData.monthConcerned,
      qualifier: paramData.qualifier,
      uploadStatus: paramData.uploadStatus,
      fileIds: paramData.fileIds
    }
    const endpoint = 'order/searchFile'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.post<OrderFilesDetailsRequest, OrderFilesDetailsResponseDTO>(endpoint, reqBody, { headers })
    return {
      content: response.data,
      status: response.status
    }
  }

  async viewOrderFilesDetailData (paramData: ViewOrderFilesDetailsRequest): Promise<any> {
    const queryString = 'fileId=' + paramData.fileId + '&pageNumber=' + paramData.pageNumber + '&pageSize=' + paramData.pageSize + '&sortBy=' + paramData.sortBy
    const endpoint = 'order/viewOrderUploadedDetails?' + queryString
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.get<ViewOrderFilesDetailsResponseDTO[]>(endpoint, { headers })
    return {
      content: response.data,
      status: response.status
    }
  }

  async deleteOrderFileData (param: DeleteOrderFileRequest): Promise<DeleteOrderFileResponse> {
    const queryString = 'fileId=' + param.fileId
    const endpoint = 'order/deleteOrderFile?' + queryString
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.delete<DeleteOrderFileResponse>(endpoint, { headers })
    return {
      status: response.status,
      message: response.data.message
    }
  }

  async orderDetailData (paramData: ViewOrderFilesDetailsRequest): Promise<any> {
    const queryString = 'orderId=' + paramData.orderId // + '&pageNumber=' + paramData.pageNumber + '&pageSize=' + paramData.pageSize + '&sortBy=' + paramData.sortBy
    const endpoint = 'order/fetchOrderDetails?' + queryString
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    // const response = await xhr.post<OrderFilesDetailsRequest, OrderFilesDetailsResponseDTO>(endpoint, reqBody, { headers })
    const response = await xhr.get<ViewOrderFilesDetailsResponseDTO[]>(endpoint, { headers })
    return {
      content: response.data,
      status: response.status
    }
  }

  async updateOrderDetailsData (paramData: UpdateOrderDetailsRequest): Promise<any> {
    const endpoint = 'order/updateOrderDetails'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.put<UpdateOrderDetailsRequest, any>(endpoint, paramData, { headers })
    return {
      content: response.data,
      status: response.status
    }
  }

  async viewOrderProcessLogsData (paramData: ViewOrderFilesDetailsRequest): Promise<any> {
    const queryString = 'fileId=' + paramData.fileId + '&pageNumber=' + paramData.pageNumber + '&pageSize=' + paramData.pageSize // + '&sortBy=' + paramData.sortBy
    const endpoint = 'order/viewProcessLog?' + queryString
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    // const response = await xhr.post<OrderFilesDetailsRequest, OrderFilesDetailsResponseDTO>(endpoint, reqBody, { headers })
    const response = await xhr.get<ViewOrderProcessLogsResponseDTO[]>(endpoint, { headers })
    return {
      content: response.data,
      status: response.status
    }
  }

  async getOrderTemplateData (): Promise<any> {
    const endpoint = 'order/downloadTemplate'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.get<any>(endpoint, { headers })
    return {
      content: response.data,
      status: response.status
    }
  }
}
